import graphql__5294c7c983fe7e6d40de from "./__generated__/SlideCaption_slide.graphql.js";import { useRef } from "react";
import { graphql, useFragment } from "react-relay";

import { hasHtmlContent, cleanHtml } from "../Utils/htmlStringUtils";
import { useMapContext } from "../Maps/MapContext";
import { useDeferredEffect } from "../Utils/useDeferredEffect";
import { isEmpty } from "lodash";

const SlideCaption = props => {
  const { caption } = useFragment(SlideCaption_slide, props.slide);

  const elementRef = useRef(null);
  const isDisplayedWithinMapSidebar = !isEmpty(useMapContext());

  // This is a fix to handle the caption vertical positionning which doesn't seem to
  // display well when the carousel is displayed in a map sidebar.
  useDeferredEffect(() => {
    const captionContainer = elementRef.current;

    if (!isDisplayedWithinMapSidebar || !captionContainer) return;

    captionContainer.style.transform = `translateY(${captionContainer.clientHeight}px)`;
  }, [isDisplayedWithinMapSidebar]);

  if (!hasHtmlContent(caption)) return null;

  return (
    <div
      className="slide-caption padding-x-sm padding-y-xs bg-black-60 text-small"
      dangerouslySetInnerHTML={{ __html: cleanHtml(caption) }}
      ref={elementRef}
    />
  );
};

const SlideCaption_slide = graphql__5294c7c983fe7e6d40de;

export default SlideCaption;
